import { useEffect } from 'react';
import { useUserAdminStore } from '../store/userAdminStore';

/**
 * Hook custom pour l'administration des utilisateurs.
 * Charge automatiquement les donnees au montage et re-fetche quand les filtres/page changent.
 */
export function useUserAdmin() {
  const store = useUserAdminStore();

  // Charger les stats au montage
  useEffect(() => {
    store.fetchStats();
  }, []);

  // Charger les utilisateurs quand la page ou les filtres changent
  useEffect(() => {
    store.fetchUsers();
  }, [store.currentPage, store.filters]);

  return store;
}
